import { useState, useEffect } from 'react'
import { getVideoViewCount } from '../apis/post/VideoAPI';

type Props = {
    originalFile: string
}

export const useGetVideoViewCount = ( { originalFile }: Props ) => {

    const [ videoViewCount, setVideoViewCount ] = useState( 0 );

    useEffect( () => {
        originalFile && fetchVideoViewCount()
    }, [ originalFile ] )

    const fetchVideoViewCount = async () => {
        try {
            const { data } = await getVideoViewCount( { videoURL: originalFile } )
            setVideoViewCount( data.videoViewCount )
        }
        catch ( e ) {
            console.log( e )
        }
    }
    return videoViewCount
}
